import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './interest-master.reducer';

export const InterestMasterDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const interestMasterEntity = useAppSelector(state => state.interestMaster.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="interestMasterDetailsHeading">
          <Translate contentKey="reachamyApp.interestMaster.detail.title">InterestMaster</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{interestMasterEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="reachamyApp.interestMaster.name">Name</Translate>
            </span>
          </dt>
          <dd>{interestMasterEntity.name}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="reachamyApp.interestMaster.value">Value</Translate>
            </span>
          </dt>
          <dd>{interestMasterEntity.value}</dd>
        </dl>
        <Button tag={Link} to="/interest-master" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/interest-master/${interestMasterEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default InterestMasterDetail;
